"use client";
import { StyledCustomFieldSubtitle } from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomOptionHeading/styles";
import { type ProcessedOption } from "@/components/site-builder/modules/CustomFormModule/types";

export interface CustomOptionHeadingProps {
  option: ProcessedOption;
}

export default function CustomOptionHeading(props: CustomOptionHeadingProps) {
  const { option } = props;

  return (
    <StyledCustomFieldSubtitle label={option.label} level={option.level} />
  );
}
